import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './SavedFeaturedProfile.scss';
import { deleteRequest } from '../../requestUtils';

const renderRoles = (name, roles) => {
  if (roles && roles.length > 0) {
    return (
      <div className="role">
        <div className="body-text-2 medium-weight role-name">{name}</div>
        {roles.map((role) => (
          <span
            key={role[0]}
            className="badge small blue-light"
          >
            {role[0]}
            {role[1] && <span className="heading-extra-text ms-2">{role[1]}</span>}
          </span>
        ))}
      </div>
    );
  }
  return null;
};

class SavedFeaturedProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hidden: false,
      email: props.email || '',
      validForm: false,
    };
    this.handleDeleteConsultant = this.handleDeleteConsultant.bind(this);
  }

  handleDeleteConsultant() {
    const { saveConsultantUrl, csrfToken } = this.props;

    deleteRequest(
      saveConsultantUrl,
      csrfToken,
    ).then((response) => {
      this.setState({ hidden: true });
      if (response.data.redirect_url) {
        window.location = response.data.redirect_url;
      }
    });
  }

  renderOverview() {
    const { featuredProfile, userLink } = this.props;
    return (
      <div>
        <div className="header">
          <div className="g-flex-8">
            <div className="body-text-2 mr-8 mb-4 transform-name">
              <div className="header-1">
                <table>
                  <tr>
                    <td className="table-row">
                      <a href={userLink} className="header-1">
                        {featuredProfile.name}
                      </a>
                    </td>
                    <td>
                      <button
                        id="remove-consultant"
                        className="remove-consultants"
                        onClick={this.handleDeleteConsultant}
                      >
                        Remove
                      </button>
                    </td>
                  </tr>
                </table>
              </div>
              {featuredProfile.city
                && (
                <div className="body-text-2 muted-gray-text">
                  <i className="fa fa-map-marker-alt mr-5" />
                  <span>{featuredProfile.city}</span>
                </div>
                )}
            </div>
          </div>
        </div>

      </div>
    );
  }

  renderSkills() {
    const { featuredProfile, projectTags } = this.props;

    let criteria = projectTags.aoe || [];
    if (projectTags.ta) { criteria = criteria.concat(projectTags.ta); }
    if (projectTags.therapy) { criteria = criteria.concat(projectTags.therapy); }

    const skills = featuredProfile.area_of_expertises.concat(
      featuredProfile.therapeutic_areas.concat(
        featuredProfile.therapies,
      ),
    ).sort((a, b) => (criteria.includes(a) ? 0 : 1) - (criteria.includes(b) ? 0 : 1));

    if (skills && skills.length > 0) {
      return (
        <div className="skill">
          {skills.map((skill) => (
            <span
              key={skill}
              className={`badge small ${criteria.includes(skill) ? 'purple-base' : 'blue-light'}`}
            >
              {skill}
            </span>
          ))}
        </div>
      );
    }
    return null;
  }

  render() {
    const { featuredProfile, isRep, truncated } = this.props;
    const { hidden } = this.state;
    return (hidden ? '' : [
      <div
        className="consultant-card"
      >
        <table>
          <tr>
            <td className="consultant-info" valign="top">
              {this.renderOverview(isRep)}
              <div className="tags">
                {renderRoles('', featuredProfile.higher_level_roles.slice(0, 3))}
              </div>

              <div className="heading">
                Expertise Areas
              </div>

              { !truncated
              && (
              <div className="tags">
                {this.renderSkills()}
              </div>
              )}
            </td>
          </tr>
        </table>
      </div>,
    ]);
  }
}

SavedFeaturedProfile.propTypes = {
  projectTags: PropTypes.shape({}).isRequired,
  featuredProfile: PropTypes.shape({}).isRequired,
  csrfToken: PropTypes.string.isRequired,
  email: PropTypes.string,
  userLink: PropTypes.string.isRequired,
  isRep: PropTypes.bool,
  truncated: PropTypes.bool,
  saveConsultantUrl: PropTypes.string.isRequired,
};

SavedFeaturedProfile.defaultProps = {
  truncated: false,
};

export default SavedFeaturedProfile;
